(function () {
  function initReveal() {
    var els = document.querySelectorAll('.fe-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('fe-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (!entry.isIntersecting) return;
        setTimeout(function () { entry.target.classList.add('fe-visible'); }, i * 90);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initFaq() {
    var items = document.querySelectorAll('.fe-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('.fe-faq__pregunta');
      var res = item.querySelector('.fe-faq__respuesta');
      if (!btn || !res) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('fe-abierto');
        item.classList.toggle('fe-abierto', !abierto);
        res.style.maxHeight = abierto ? null : res.scrollHeight + 'px';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFaq();
  });
})();
